<button class="loading-button" [attr.data-variant]="variant" [attr.data-size]="size" [attr.data-loading]="loading"
  [attr.data-disabled]="disabled" [disabled]="disabled || loading"
  [attr.aria-label]="loading ? (loadingText || 'Loading...') : label" (click)="onButtonClick($event)" type="button">

  <!-- Phosphor Icon Spinner -->
  <span *ngIf="loading" class="loading-spinner" aria-hidden="true">
    <umss-icon [name]="spinnerIconName" [size]="spinnerSize"></umss-icon>
  </span>

  <!-- Button text -->
  <span class="button-text">{{ displayText }}</span>
</button>